export const SHOW_HELP_PARAM = 'showHelp';
export const HELP_VIEW_PARAM = 'view';
export const HELP_SECTION_PARAM = 'expand';
